import {
  HIDE_MODAL,
  SHOW_MODAL,
  HIDE_ALERT,
  SHOW_ALERT,
  HIDE_FORM_SECTION,
  SHOW_FORM_SECTION,
  SET_COMMIT_FORM_VERSION,
  MOBILE_UPDATE_CLAIM_STEP,
  ACTIVATE_TAB,
} from '../actions/ui';

const initialState = {
  formSections: {},
  modals: {},
  alerts: {},
  activeTab: null,
  commitFormVersion: null,
  mobile: {
    claimStep: 1,
  },
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case HIDE_FORM_SECTION:
      return {
        ...state,
        formSections: { ...state.formSections, [payload]: false },
      };
    case SHOW_FORM_SECTION:
      return {
        ...state,
        formSections: { ...state.formSections, [payload]: true },
      };
    case SHOW_MODAL:
      return {
        ...state,
        modals: {
          ...state.modals,
          [payload.name]: payload,
        },
      };
    case HIDE_MODAL:
      return {
        ...state,
        modals: { ...state.modals, [payload.name]: null },
      };
    case SHOW_ALERT:
      return {
        ...state,
        alerts: {
          ...state.alerts,
          [payload.name]: payload,
        },
      };
    case HIDE_ALERT:
      return {
        ...state,
        alerts: { ...state.alerts, [payload.name]: null },
      };
    case SET_COMMIT_FORM_VERSION:
      return {
        ...state,
        commitFormVersion: payload.name,
      };
    case MOBILE_UPDATE_CLAIM_STEP:
      return {
        ...state,
        mobile: {
          ...state.mobile,
          claimStep: payload.step,
        },
      };
    case ACTIVATE_TAB:
      return {
        ...state,
        activeTab: payload.tabName,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/ui.reducer.js